import { render } from "./ProductExplanItem.vue?vue&type=template&id=68cbbc26&scoped=true"
import script from "./ProductExplanItem.vue?vue&type=script&lang=js"
export * from "./ProductExplanItem.vue?vue&type=script&lang=js"

import "./ProductExplanItem.vue?vue&type=style&index=0&id=68cbbc26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68cbbc26"]])

export default __exports__